import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Getters, Mutations, Actions, JobCards, JobType } from '@/models/JobCard.model';

// Inital state
const state: JobCards = {
  openJobCards: [],
  closedJobCards: [],
  jobTypes: [],
}

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, JobCards> = {
  // YAY! no complex nested objects to worry about here - https://github.com/vuejs/vue/issues/4292 complex nested objects are not reactive
  emptyLineItem: (state) => {
    return {
      id: 0,
      description: '',
      cost: 0,
    };
  },

  emptyVehicleOdometers: (state) => {
    return {
      vehicle1Odometer: 0,
      vehicle1OdometerDue: 0,
      vehicle1NextOdometerDue: 0,
    };
  },


  openJobCards: (state) => state.openJobCards,
  closedJobCards: (state) => state.closedJobCards,
  jobTypes: (state) => state.jobTypes,

  jobTypeIconByTypeId: (state) =>  (typeId: number): string | undefined => {
    const foundIndex = state.jobTypes.findIndex((item: JobType) => item.id === typeId);

    if (foundIndex >= 0) {
      return state.jobTypes[foundIndex].icon;
    } else {
      return undefined;
    }
  },
}

// TODO: Change mutation names to uppercase ( Standards )
// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, JobCards> = {
  setOpenJobCards(state, { jobCards }) {
    state.openJobCards = jobCards;
  },

  setClosedJobCards(state, { jobCards }) {
    state.closedJobCards = jobCards;
  },

  setJobTypes(state, { jobTypes }) {
    state.jobTypes = jobTypes;
  },
}

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, JobCards, Mutations, Getters> = {
  setOpenJobCards({ commit }, payload) {
    commit('setOpenJobCards', payload);
  },

  setClosedJobCards({ commit }, payload) {
    commit('setClosedJobCards', payload);
  },

  setJobTypes({ commit }, payload) {
    commit('setJobTypes', payload);
  },
}

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<JobCards, Getters, Mutations, Actions>('JobCardModule');

export const JobCardsModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
